import { API_BASE } from "../../config/env";
import { formatToISO } from "../../helpers/Helpers";
import axios from "axios";
export const FETCH_PATIENTREGISTER_FULFILLED = "FETCH_PATIENTREGISTER_FULFILLED";
export const FETCH_PATIENTREGISTER_REJECTED = "FETCH_PATIENTREGISTER_REJECTED";
export const FETCH_PATIENTREGISTER_PENDING = "FETCH_PATIENTREGISTER_PENDING";
export const RESET_PATIENTREGISTER = "RESET_PATIENTREGISTER"



export function patientRegister(firstName, lastName, birthDate, gender, identityNumber) {
    const user = JSON.parse(localStorage.getItem("user"))
    const accessToken = localStorage.getItem("accessToken")
    const refreshToken = localStorage.getItem("refreshToken")
    const data = {
        UserId: user.id,
        FirstName: firstName,
        lastName: lastName,
        dateOfBirth: formatToISO(birthDate),
        gender: parseInt(gender),
        identityNumber: identityNumber,
        passportNumber: "",
        nationalityCode: "TUR",
        hasETKApproval: true,
        hasKVKKApproval: true,
        hasMailActivation: true,
        careProviderID: "",
        patientType: null,
        contactInfo: {
            patientID: "",
            phoneNumber: "",
            emailAddress: "",
            address: "",
            addressLongitude: 0,
            addressLatitude: 0,
            relativeFullName: "",
            relativePhoneNumber: ""
        }
    }
    const data_json = JSON.stringify(data)
    return (dispatch) => {
        dispatch({
            type: "FETCH_PATIENTREGISTER",
            payload: axios({
                method: "post",
                url: `${API_BASE}/api/v2/patient`,
                data: data_json,
                headers: {
                    "Authorization": "Bearer " + accessToken,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("Client-Id"),
                    "One-Id": localStorage.getItem("One-Id"),
                    "Refresh-Token": refreshToken,
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning" : "69920"
                },
            }).then((result) => result.data),
        });
    };
}


export function resetPatientRegister() {
    return (dispatch) => {
        dispatch({
            type: "RESET_PATIENTREGISTER",
        });
    };
  }



